import React from 'react';
import { Route } from 'react-router-dom';
import Bench from '../Bench/Bench';
import BenchProvider from '../Bench/BenchProvider';
import Chain from '../Chain/Chain';
import ChainReputation from '../ChainReputation/ChainReputation';
import Project from '../Project/Project';
import ProjectReputation from '../ProjectReputation/ProjectReputation';
import UserReview from '../Reviews/UserReviews';
import ProtectedRoute from './ProtectedRoute';

const ProfileRoutes = () => {
  return (
    <Route
      path='/profile'
      element={
        <ProtectedRoute>
          <BenchProvider />
        </ProtectedRoute>
      }
    >
      <Route path='/profile' element={<Bench />} />
      <Route path='/profile/:userAddress/projects' element={<ProjectReputation />} />
      <Route path='/profile/:userAddress/chains' element={<ChainReputation />} />
      <Route path='/profile/:userAddress/takes' element={<UserReview />} />
      {/* <Route path='/bench/:userAddress/peers' element={<Peer pageAnimation={pageAnimation} />} /> */}
      <Route path='/profile/:userAddress/chains/:chainId' element={<Chain />} />
      <Route path='/profile/:userAddress/projects/:projectName' element={<Project />} />
    </Route>
  );
};

export default ProfileRoutes;
